import { frontendURL } from '../../../helper/URLHelper';
import OrderIssuesView from './OrderIssuesView.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/order-issues'),
      name: 'order_issues_dashboard',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: OrderIssuesView,
      props: () => ({ type: 'active' }),
    },
    {
      path: frontendURL('accounts/:accountId/order-issues/archive'),
      name: 'order_issues_archive',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: OrderIssuesView,
      props: () => ({ type: 'archive' }),
    },
  ],
};
